import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Logo } from '../ui/logo';
import { LinkedInIcon, XIcon, InstagramIcon, FacebookIcon } from '../ui/icons';

// eslint-disable-next-line import/prefer-default-export
export function LandingFooter() {
  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const token = useSelector((state: any) => state.user && state.user.token);
  const logoHref = token ? '/dashboard' : '/';

  return (
    <footer className="bg-slate-900 text-slate-300 py-12 border-t border-slate-800">
      <div className="container mx-auto px-6">
        <div className="flex justify-center lg:justify-start mb-6">
          <Logo href={logoHref} variant="white" />
        </div>
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start gap-8 text-center lg:text-left">
          <p className="max-w-md text-base leading-relaxed text-slate-300">
            Structured recruiting + measurable results = the most effective and cost-efficient way to
            hire.
          </p>
          <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-6">
            <div className="flex items-center gap-6 font-medium">
              <a href="/privacy" className="whitespace-nowrap hover:text-white transition-colors">
                Privacy Policy
              </a>
              <a href="/terms" className="whitespace-nowrap hover:text-white transition-colors">
                Terms of Service
              </a>
              <a href="/contact" className="whitespace-nowrap hover:text-white transition-colors">
                Contact Us
              </a>
            </div>
            <span className="hidden lg:block text-slate-600">|</span>
            <div className="flex items-center gap-4">
              <a
                href="https://www.linkedin.com/company/boosthiring"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="text-slate-400 hover:text-white transition-colors"
              >
                <LinkedInIcon className="w-5 h-5" />
              </a>
              <a
                href="https://x.com/BoostHiringHQ"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X"
                className="text-slate-400 hover:text-white transition-colors"
              >
                <XIcon className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/boosthiring"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-slate-400 hover:text-white transition-colors"
              >
                <InstagramIcon className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61590933320508"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-slate-400 hover:text-white transition-colors"
              >
                <FacebookIcon className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-slate-800 text-center text-slate-300">
          <p>&copy; {currentYear} BoostHiring&trade;. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
